import * as yup from 'yup';
import ValidationUtil from "../Utils/ValidationUtil";

class MessageValidation {

    static async validate(form) {
        try {
            let objectValidate = {
                subject: yup
                    .string()
                    .max(255, ValidationUtil.MSG_FIELD_MAX)
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
                body: yup
                    .string()
                    .required(ValidationUtil.MSG_FIELD_REQUIRED),
            };

            if (!form.send_to_all) {
                objectValidate.client_uuids = yup
                    .array()
                    .of(yup.string())
                    .min(1, 'Selecione ao menos um cliente ou marque enviar para todos os clientes')
                    .required('Selecione ao menos um cliente ou marque enviar para todos os clientes');
            }

            let validate = yup.object().shape(objectValidate);

            validate.validateSync(form, {abortEarly: false});

            return true;

        } catch (e) {
            let erros = [];
            e.inner.forEach(function (value, index) {
                erros[value.path] = value.message;
            });

            return erros;
        }
    }

}

export default MessageValidation;
